import React from 'react';
export var DataLoaderContextComponent = React.createContext(undefined);
export function ensureContext(context) {
    if (!context) {
        throw new Error('Data loader context missing, ensure you have wrapped your application in a DataLoaderProvider');
    }
    return context;
}
export function ssrNeedsData(state) {
    return !state || (!state.data.hasData && state.lastAction.success);
}
//# sourceMappingURL=data-loader-context.js.map